import { render, staticRenderFns } from "./Weblogs.vue?vue&type=template&id=650b08ae&scoped=true"
import script from "./Weblogs.vue?vue&type=script&lang=js"
export * from "./Weblogs.vue?vue&type=script&lang=js"
import style0 from "./Weblogs.vue?vue&type=style&index=0&id=650b08ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650b08ae",
  null
  
)

export default component.exports